import { MAIN_PURPLE } from "../../utils/constants/colorsConstants";

const VioletSunsetDesktop = (props) => {
  const { navigateToWaitlist } = props;

  return (
    <div
      id="violet-sunset-body-desktop"
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        gap: "4.75rem",
        width: "100%",
        height: "100%",
        padding: "0 96px",
        justifyContent: "center",
      }}
    >
      <div
        id="violet-sunset-text-and-logo"
        style={{
          display: "flex",
          alignItems: "start",
          gap: "4.75rem",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center image-container"
          style={{ width: "377px", height: "377px", marginTop: "0.25rem" }}
        >
          <img
            src="images/yoga-guy.png"
            srcSet="images/yoga-guy2x.png, images/yoga-guy3x.png"
            className="firstImage Artboard-102x-100-1"
            alt="logo"
            style={{ display: "block", width: "377px", height: "377px" }}
            id="first-image"
          ></img>
          <img
            src="images/peopleTalking.png"
            srcSet="images/peopleTalking2x.png,
          images/peopleTalking3x.png"
            className="secondImage Artboard-102x-100-1"
            alt="logo"
            style={{ display: "none", width: "377px", height: "377px" }}
          ></img>
          <img
            src="images/yogaGirl3.png"
            srcSet="images/yogaGirl32x.png,
          images/yogaGirl33x.png"
            className="thirdImage Artboard-102x-100-1"
            alt="logo"
            style={{ display: "none", width: "377px", height: "377px" }}
          ></img>
        </div>

        <div
          id="violet-sunset-text"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
          }}
        >
          <div
            id="violet-sunset-title-subtitle"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              fontFamily: "PoppinsBold !important",
            }}
          >
            <h1
              style={{
                fontSize: "1.5rem",
                lineHeight: "24px",
                color: MAIN_PURPLE,
                fontFamily: "PoppinsSemiBold",
              }}
            >
              violet is moving to TiJUBU
            </h1>
            <h2
              style={{
                fontSize: "3rem",
                lineHeight: "4rem",
                color: "black",
                fontFamily: "PoppinsBold",
              }}
            >
              Your well-being will soon <br /> be even more incredible.
            </h2>
          </div>
          <p
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              color: "black",
              fontFamily: "PoppinsRegular",
            }}
          >
            You’ve witnessed the spark to help you be well on violet.
            <br />
            <br />
            That power will continue in TiJUBU with deeper insights, bigger{" "}
            purpose, same you.
            <br />
            <span>Your incredible journey of you becoming you.</span>
          </p>{" "}
          <button
            type="button"
            style={{
              alignSelf: "center",
              width: "100%",
              backgroundColor: MAIN_PURPLE,
              color: "white",
              border: "none",
              padding: "1rem 1.5rem",
              borderRadius: "2rem",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
            onClick={navigateToWaitlist}
          >
            Join the waitlist
          </button>
        </div>

        <img
          src="images/TiJUBU-Vertical-Logo.png"
          alt="logo"
          id="TiJUBU-logo"
          style={{ width: "auto", height: "340px" }}
        />
      </div>
    </div>
  );
};

export default VioletSunsetDesktop;
